import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';
import toast from 'react-hot-toast';

import { CartItem } from '../../types/cart';
import { serializeCart } from './getCart';

const appendItemToCart = async (item: CartItem, cartId: string) => {
  const endPoint = `${apiConfig('magento')}/default/V1/carts/mine/items/custom`;

  const cartItem: any = {
    qty: item.quantity,
    quote_id: `${cartId}`,
  };

  // adding sku only when we don't have cart item id, i.e when adding a new item to cart
  if (!!item?.cartItemId) {
    cartItem.item_id = item.cartItemId;
  } else if (item?.productSku) {
    cartItem.sku = item.productSku;
  }

  if (item?.productOption) {
    cartItem.product_option = item.productOption;
  }

  const body: any = {
    cart_item: cartItem,
  };

  const { response, error }: any = await postMethod({
    endPoint,
    body,
    headers: getDefaultHeaders({ deviceId: true }),
    enableErrorHandling: true,
  });

  if (response?.data) {
    return serializeCart(response.data);
  }
  // else if (error) {
  //   toast.error(error?.message || 'Something went wrong');
  // }

  return null;
};

export default appendItemToCart;
